import { ImageNone } from '@cian/image-none-component';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';
import { Slider } from '../slider';
import { GalleryItemPreloader } from './preloader';

const style = require('./index.css');

export interface IGalleryProps extends Readonly<{ children?: React.ReactNode[] }> {
  defaultIndex?: number;
  controlsHidden?: boolean;
  onSlideChanged?(): void;
  controlButtonsFullHeight?: boolean;
}

export interface IGalleryState {
  items: React.ReactNode[];
  itemsTotal: number;
  sliderInitialized: boolean;
}

export class Gallery extends React.Component<IGalleryProps, IGalleryState> {
  public slider: Slider | null = null;

  public constructor(props: IGalleryProps) {
    super(props);

    this.state = {
      items: React.Children.toArray(React.Children.map(props.children, (child, index) => {
        return (
          <GalleryItemPreloader
            key={`item_${index}`}
          >
            {React.Children.only(child)}
          </GalleryItemPreloader>
        );
      })),
      itemsTotal: React.Children.count(props.children),
      sliderInitialized: false,
    };
  }

  public componentWillReceiveProps(nextProps: IGalleryProps) {
    if (this.props.children !== nextProps.children) {
      this.setState({
        items: React.Children.toArray(React.Children.map(nextProps.children, (child, index) => {
          return (
            <GalleryItemPreloader
              key={`item_${index}`}
            >
              {React.Children.only(child)}
            </GalleryItemPreloader>
          );
        })),
        itemsTotal: React.Children.count(nextProps.children),
      });
    }
  }

  public render() {
    return (
      <div className={style.container}>
        {React.Children.count(this.props.children) > 0 && <Slider
          ref={(slider) => this.slider = slider }
          defaultIndex={this.props.defaultIndex}
          onSliderInitialized={this.onSliderInitialized}
          onSlideChange={this.onSlideChange}
        >
          {this.state.items}
        </Slider>}
        {React.Children.count(this.props.children) === 0 && <ImageNone />}
        <div className={style.controls} style={{ display: this.props.controlsHidden ? 'none' : ''}}>
          {this.renderControls()}
          {this.renderCounter()}
        </div>
      </div>
    );
  }

  private renderControls() {
    if (!this.state.sliderInitialized || this.state.itemsTotal < 2) {
      return null;
    }

    return (
      <div {...mergeStyles(
        this.props.controlButtonsFullHeight && style['controls-full-height'],
      )}>
        <button className={style['controls-prev']} onClick={(e) => {
          e.stopPropagation();
          if (this.slider) {
            this.slider.prev();
          }
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.57 38" width="13" height="23">
            <path fill="none" stroke="currentColor" strokeWidth="4"
              d="M18.54 2L2 18.86 18.57 36" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <button className={style['controls-next']} onClick={(e) => {
          e.stopPropagation();
          if (this.slider) {
            this.slider.next();
          }
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.57 38" width="13" height="23">
            <path fill="none" stroke="currentColor" strokeWidth="4"
              d="M2.03 36l16.54-16.86L2 2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    );
  }

  private renderCounter() {
    if (!this.slider || !this.state.sliderInitialized || this.state.itemsTotal < 1) {
      return null;
    }

    return (
      <div className={style['controls-counter']}>
        {`${this.slider.currentIndex + 1} из ${this.state.itemsTotal}`}
      </div>
    );
  }

  private onSliderInitialized = () => {
    this.setState({
      sliderInitialized: true,
    });
  }

  private onSlideChange = (index: number) => {
    this.forceUpdate();

    if (this.props.onSlideChanged) {
      this.props.onSlideChanged();
    }
  }
}

export * from './image';
